import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'stylistStore',
directives: {
TransferDom
},
components: {
Tab,
TabItem,
Scroller,
XButton,
Confirm,
Popup
},
data () {
return {
isPriceSort: false,
isSalesSort: false,
isLatestSort: false,
designerInfo: '',
list: [],
page: 1,
categoryCode: '08',
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
CategoryList: [],
tabActiveIndex: 0,
scrollTop: 0
}
},
methods: {
priceSort (item, index) { //价格
this.tabActiveIndex = index
this.isPriceSort = !this.isPriceSort
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.categoryCode = item.categoryCode
this.loadMore()
},
onScroll (pos) {
this.scrollTop = pos.top
},
backTop () {
let that = this;
(function smoothscroll(){
var currentScroll = that.scrollTop;
if (currentScroll > 0) {
window.requestAnimationFrame(smoothscroll);
that.$nextTick(() => {
that.$refs.scrollerBottom.reset({top: currentScroll - 500})
})

}else{
that.$nextTick(() => {
that.$refs.scrollerBottom.reset({top: 0})
})
}
})();
},
getDesignerInfo () {
this.$request.post('/design/DesignerInfo',{
designerId: this.$route.query.designerId
}).then(data => {
if(data.code == 0){
this.designerInfo = data.obj
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
fetchData(cb) {
this.$request.post('/design/listByDesignShop',{
page: this.page,
rows: 10,
designerId: this.$route.query.designerId,
categoryCode: this.categoryCode,
}).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
detail (item) {
this.$router.push({
path: '/commodity',
query: {
id: item.id,
}
})
console.log(JSON.parse(JSON.stringify(item)))
},
getCategoryList () {
this.$request.post('/design/categorycount',{
designerId: this.$route.query.designerId
}).then(data => {
if(data.code == 0){
this.CategoryList = data.obj.filter((item, index) => {
return item.spuCount != 0
})
console.log(JSON.parse(JSON.stringify(this.CategoryList)))
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
},
created () {
this.getCategoryList()
this.getDesignerInfo()
},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
}



// WEBPACK FOOTER //
// ./src/views/stylistStore/script.js